<div class="section">
  <div class="heading-primary">{{ $t('shopping.basket.checkout.shipping') }}</div>
  <ul class="list">
    <li>
      <CheckoutAddress />
    </li>
    <li>
      <ShippingMethods />
    </li>
    <li>
      <Packaging />
    </li>
  </ul>
</div>
